export const ICTMENU_LOG_ACTION_TYPES = {
  goBJ: {
    actCode: 'ict_ch',
    contentsType: 'bj',
    contentsValue: null  // userId는 실행시점에 주입
  },
  clickNote: {
    actCode: 'ict_note',
    contentsType: '',
    contentsValue: ''
  },
  favorite: {
    actCode: 'ict_fav',
    contentsType: '',
    contentsValue: ''
  },
  nickSearch: {
    actCode: 'ict_search',
    contentsType: '',
    contentsValue: ''
  }
};